import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {
  IconButton,
  Paper,
  Stack,
  styled,
  Table,
  TableHead,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableRow
} from '@mui/material';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    width: '100%'
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#757575',
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

const ViewLinksComponent = props => {
  const { MapProps } = props;
  const heightIframe = window.innerHeight - window.innerHeight / 5;
  const { viewLinks } = MapProps.map.settingsAdvancedMap;
  const defaultValues = [
    {
      type: 'url',
      value: 'https://srmconsulting.es/',
      name: 'SRM Consulting'
    }
  ];
  const startLink = !isEmpty(viewLinks) ? viewLinks[0] : defaultValues[0];

  const [count, setCount] = React.useState(0);
  const [link, setLink] = React.useState(startLink);
  const totalCount = !isEmpty(viewLinks) ? viewLinks.length : defaultValues.length;

  const handleEndValue = () => {
    const lenghtValues = totalCount - 1;
    const element = viewLinks[lenghtValues];
    setLink(element);
    setCount(lenghtValues);
  };
  const handleStartValue = () => {
    const element = viewLinks[0];
    setLink(element);
    setCount(0);
  };

  const handleLeftValue = () => {
    if (count > 0) {
      const newCont = count - 1;
      const element = viewLinks[newCont];
      setCount(newCont);
      setLink(element);
    }
  };
  const handleRightValue = () => {
    const lenghtValues = viewLinks.length - 1;
    if (count < lenghtValues) {
      const newCont = count + 1;
      const element = viewLinks[newCont];
      setCount(newCont);
      setLink(element);
    }
  };

  const adjustURL = url => {
    let adjustedURL = url;
    if (!/^https?:\/\//i.test(url)) {
      adjustedURL = `https://${url}`;
    }
    return adjustedURL;
  };

  return (
    <>
      <Paper>
        <TableContainer component={Paper}>
          <Table aria-label="customized table" size="small" stickyHeader>
            <TableHead>
              <StyledTableRow
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                directon="row"
              >
                <StyledTableCell align="left">
                  <Stack
                    color="inherit"
                    size="small"
                    direction="row"
                    justifycontent="flex-start"
                    alignitems="left"
                    spacing={0}
                  >
                    {count !== 0 && totalCount !== 0 && (
                      <>
                        <IconButton aria-label="comments" onClick={handleStartValue}>
                          <KeyboardDoubleArrowLeftIcon />
                        </IconButton>
                        <IconButton aria-label="comments" onClick={handleLeftValue}>
                          <KeyboardArrowLeftIcon />
                        </IconButton>
                      </>
                    )}
                  </Stack>
                </StyledTableCell>

                <StyledTableCell justifcontent="center" align="center" width="100%">
                  {`${link.name}  ${count + 1}/${totalCount}`}
                </StyledTableCell>

                <StyledTableCell align="right">
                  <Stack
                    color="inherit"
                    size="small"
                    direction="row"
                    justifyContent="flex-end"
                    alignitems="right"
                    spacing={0}
                  >
                    {count !== totalCount - 1 && totalCount !== 0 && (
                      <>
                        <IconButton aria-label="comments" onClick={handleRightValue}>
                          <KeyboardArrowRightIcon />
                        </IconButton>
                        <IconButton aria-label="comments" onClick={handleEndValue}>
                          <KeyboardDoubleArrowRightIcon />
                        </IconButton>
                      </>
                    )}
                  </Stack>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </Paper>
      {link.type === 'html' ? (
        // eslint-disable-next-line react/no-danger
        <div dangerouslySetInnerHTML={{ __html: link.value }} />
      ) : (
        <iframe
          src={adjustURL(link.value)}
          width="100%"
          height={`${heightIframe}px`}
          align="center"
          title="ViewLinks"
        />
      )}
    </>
  );
};

ViewLinksComponent.defaultProps = {};
ViewLinksComponent.propTypes = {
  MapProps: PropTypes.object.isRequired
};

export default ViewLinksComponent;
